import React from "react";
import { CountdownTimer } from "../common";

const SubscriptionComplete = ({ drawTime, subscribedAt }) => {
  return (
    <div className="newyear-subscription-complete">
      <div className="newyear-subscription-complete__icon">
        <span className="newyear-subscription-complete__emoji">
          &#10004;
        </span>
      </div>

      <h2 className="newyear-subscription-complete__title">청약 완료!</h2>
      <p className="newyear-subscription-complete__message">
        성공적으로 청약이 완료되었습니다.
      </p>

      {subscribedAt && (
        <p className="newyear-subscription-complete__time">
          청약 시간: {new Date(subscribedAt).toLocaleString("ko-KR")}
        </p>
      )}

      <div className="newyear-subscription-complete__draw-info">
        <p className="newyear-subscription-complete__draw-label">
          추첨까지 남은 시간
        </p>
        {drawTime && (
          <CountdownTimer deadline={drawTime} label="" />
        )}
      </div>

      <div className="newyear-subscription-complete__notice">
        <p>추첨 결과는 이 페이지에서 확인하실 수 있습니다.</p>
        <p>당첨 시 당첨자 정보 입력 안내가 표시됩니다.</p>
      </div>
    </div>
  );
};

export default SubscriptionComplete;
